'use client'

import React, { useEffect, useState } from 'react'
import { cn } from '@/utilities/ui'

export function BrandWordmark({
  html,
  className,
  fallbackHtml = 'D.R.I.V.E.',
}: {
  html?: string | null
  className?: string
  fallbackHtml?: string | null
}) {
  const [resolvedHtml, setResolvedHtml] = useState<string>(() => {
    if (html) return html
    return ''
  })

  useEffect(() => {
    if (html) {
      setResolvedHtml(html)
      return
    }
    try {
      const w = (globalThis as any)?.__brandWordmarkHtml
      if (w && typeof w === 'string' && w.trim()) {
        setResolvedHtml(w)
        return
      }
    } catch {}
    setResolvedHtml('')
  }, [html])

  const finalHtml = resolvedHtml || fallbackHtml || ''
  if (!finalHtml) return null

  return (
    <span
      className={cn('inline-flex items-center align-middle leading-none', className)}
      dangerouslySetInnerHTML={{
        __html: finalHtml,
      }}
    />
  )
}
